import { faEye, faTrash, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Success_Lottie from '../../../../../animations/success_lottie/Success_Lottie';
import Proceed_btn from '../../../../../common_components/common_btn/proceed_btn/Proceed_btn';
import "./Kyc_step_content.css";

function Kyc_step_content() {
    const [phone, setPhone] = useState('');
    const [step, setStep] = useState(1);
    const totalSteps = 3;

    const handleNextStep = () => {
        if (step < totalSteps) setStep(step + 1);
    };

    const handlePrevStep = () => {
        if (step > 1) setStep(step - 1);
    };

    const progress = (step / totalSteps) * 100;

    const stepTitles = [
        "Personal Details",
        "Attach Id Proof",
        "Complete KYC"
    ];

    const [images, setImages] = useState({
        aadhar: [],
        pan: [],
        bank: [],
    });

    const [modalImage, setModalImage] = useState(null);

    const handleMultiFileUpload = (e, field) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImages((prev) => ({
                    ...prev,
                    [field]: [...prev[field], reader.result],
                }));
            };
            reader.readAsDataURL(file);
        });
    };

    const handleDeleteImage = (field, index) => {
        setImages((prev) => ({
            ...prev,
            [field]: prev[field].filter((_, i) => i !== index),
        }));
    };

    const handleViewImage = (imgUrl) => {
        setModalImage(imgUrl);
    };

    const closeModal = () => setModalImage(null);

    return (
        <section className='Kyc_step_content'>
            {step !== 3 && (
                <div className="kyc_header">
                    <div className='heading_text_holder'>
                        <div className="step_info">
                            <div className="step_number">{`0${step}`}</div>
                            <div className="step_text_holder">
                                <div className="step_title">{stepTitles[step - 1]}</div>
                            </div>
                        </div>

                        <div className="next_text_holder">
                            <p>Next: Attach Id Proof</p>
                        </div>
                    </div>
                    <div className="step_progress">
                        <div className="circle_progress" style={{ width: "80px", height: "80px" }}>
                            <CircularProgressbar
                                value={progress}
                                text={`${step} of ${totalSteps}`}
                                styles={buildStyles({
                                    pathColor: "#00670A",
                                    textColor: "#002147",
                                    trailColor: "#e8f0ff",
                                    textSize: '20px',
                                    fontWeight: 'bold',
                                })}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className="profile_form_holder">
                <Form>
                    {step === 1 && (
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control type="text" placeholder="Pratiksha" className="form_input" />
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control type="text" placeholder="Pethe" className="form_input" />
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" placeholder="pethepratiksha234@gmail.com" className="form_input" />
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Mobile Number</Form.Label>
                                    <PhoneInput
                                        country={'in'}
                                        value={phone}
                                        onChange={(phone) => setPhone(phone)}
                                        inputClass="phone_input"
                                        buttonClass="phone_button"
                                        containerClass="phone_container"
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    )}

                    {step === 2 && (
                        <div className="kyc-id-proof-section">

                            <div className="id-proof-timeline">
                                {/* Aadhaar */}
                                <div className={`timeline-item ${images.aadhar.length > 0 ? "active" : ""}`}>
                                    <div className="timeline-dot"></div>
                                    <div className="timeline-content">
                                        <div className="proof-header">
                                            <label>Aadhar Card <span>(Front + Back)</span></label>
                                        </div>
                                        <div className="upload-block">
                                            <Form.Group>
                                                <Form.Control
                                                    type="file"
                                                    multiple
                                                    accept="image/*"
                                                    onChange={(e) => handleMultiFileUpload(e, "aadhar")}
                                                />
                                            </Form.Group>
                                            <div className="preview-multi">
                                                {images.aadhar.map((img, idx) => (
                                                    <div key={idx} className="preview-img-wrapper">
                                                        <img src={img} alt={`Aadhar ${idx + 1}`} className="preview-img" />
                                                        <div className="img-overlay">
                                                            <FontAwesomeIcon
                                                                icon={faEye}
                                                                className="img-action-btn view"
                                                                onClick={() => handleViewImage(img)}
                                                            />
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                className="img-action-btn delete"
                                                                onClick={() => handleDeleteImage("aadhar", idx)}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* PAN */}
                                <div className={`timeline-item ${images.pan.length > 0 ? "active" : ""}`}>
                                    <div className="timeline-dot"></div>
                                    <div className="timeline-content">
                                        <div className="proof-header">
                                            <p>PAN Card <span>(Front + Back)</span></p>
                                        </div>
                                        <div className="upload-block">
                                            <Form.Group>
                                                <Form.Control
                                                    type="file"
                                                    multiple
                                                    accept="image/*"
                                                    onChange={(e) => handleMultiFileUpload(e, "pan")}
                                                />
                                            </Form.Group>
                                            <div className="preview-multi">
                                                {images.pan.map((img, idx) => (
                                                    <div key={idx} className="preview-img-wrapper">
                                                        <img src={img} alt={`PAN ${idx + 1}`} className="preview-img" />
                                                        <div className="img-overlay">
                                                            <FontAwesomeIcon
                                                                icon={faEye}
                                                                className="img-action-btn view"
                                                                onClick={() => handleViewImage(img)}
                                                            />
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                className="img-action-btn delete"
                                                                onClick={() => handleDeleteImage("pan", idx)}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Bank Proof */}
                                <div className={`timeline-item ${images.bank.length > 0 ? "active" : ""}`}>
                                    <div className="timeline-dot"></div>
                                    <div className="timeline-content">
                                        <div className="proof-header">
                                            <p>Bank Passbook / Cancelled Cheque</p>
                                        </div>
                                        <div className="upload-block">
                                            <Form.Group>
                                                <Form.Control
                                                    type="file"
                                                    multiple
                                                    accept="image/*"
                                                    onChange={(e) => handleMultiFileUpload(e, "bank")}
                                                />
                                            </Form.Group>
                                            <div className="preview-multi">
                                                {images.bank.map((img, idx) => (
                                                    <div key={idx} className="preview-img-wrapper">
                                                        <img src={img} alt={`Bank ${idx + 1}`} className="preview-img" />
                                                        <div className="img-overlay">
                                                            <FontAwesomeIcon
                                                                icon={faEye}
                                                                className="img-action-btn view"
                                                                onClick={() => handleViewImage(img)}
                                                            />
                                                            <FontAwesomeIcon
                                                                icon={faTrash}
                                                                className="img-action-btn delete"
                                                                onClick={() => handleDeleteImage("bank", idx)}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="warning-text">
                                <FontAwesomeIcon icon={faTriangleExclamation} />
                                Ensure your ID proof is clear, readable, and original before uploading.
                            </div>
                        </div>
                    )}

                    {step === 3 && (
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="kyc_completed_lottie_holder">
                                    <Success_Lottie />
                                    <h4>KYC Completed!</h4>
                                    <p>Thank you for submitting your details.</p>
                                </div>



                            </div>
                        </div>
                    )}

                    <div className="col-12">
                        <div className="btn_holder">
                            {step < totalSteps && (
                                <>
                                    {step > 1 && (
                                        <Proceed_btn
                                            btnText="Back"
                                            onClick={handlePrevStep}
                                            className="cancle_btn"
                                        />
                                    )}
                                    <Proceed_btn
                                        btnText="Save & Next"
                                        onClick={handleNextStep}
                                        className="save_changes_btn"
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </Form>
            </div>

            {/* Fullscreen Image Modal */}
            <Modal show={!!modalImage} onHide={closeModal} centered size="lg" className="fullscreen-modal">
                <Modal.Body className="text-center">
                    <img src={modalImage} alt="Preview" className="fullscreen-img" />
                </Modal.Body>
            </Modal>
        </section>
    );
}

export default Kyc_step_content;
